import { useEffect, useState } from "react";
import { adminGet } from "@/lib/adminApi";

export default function Newsletter() {
  const [data, setData] = useState(null);

  useEffect(() => {
    adminGet("/newsletter").then(setData).catch(() => {});
  }, []);

  if (!data) return <p className="rav-page-sub">La lettre se prépare…</p>;

  return (
    <div data-testid="admin-newsletter-module">
      <h2 className="rav-admin-h2">Communication — La lettre douce</h2>
      <div className="rav-admin-grid">
        <div className="rav-stat-card" data-testid="newsletter-count">
          <span className="rav-stat-value">{data.count}</span>
          <span className="rav-stat-label">inscrite(s) à la lettre</span>
        </div>
      </div>
      <p className="rav-page-sub">
        L'envoi des campagnes sera activé avec le service d'e-mailing. Les inscriptions se font depuis la page Échanger
        de l'application.
      </p>

      <h2 className="rav-admin-h2">Partager l'application</h2>
      <div className="rav-admin-row rav-qr-card" data-testid="qr-share-card">
        <img src="/qr-partage.png" alt="QR Code vers respireaimevibre.com" className="rav-qr-img" data-testid="qr-share-image" />
        <div className="rav-qr-side">
          <span className="rav-admin-row-label">Le QR Code Respire Aime Vibre</span>
          <span className="rav-admin-row-sub">
            Vos clientes le scannent avec leur téléphone et arrivent directement dans l'application. Parfait sur une
            carte de visite, une plaquette ou au cabinet.
          </span>
          <span className="rav-admin-row-actions">
            <a className="rav-text-link" data-testid="qr-share-download" href="/qr-partage.png" download="qr-respire-aime-vibre.png">
              Télécharger l'image
            </a>
            <button type="button" className="rav-text-link" data-testid="qr-share-print" onClick={() => window.print()}>
              Imprimer
            </button>
          </span>
        </div>
      </div>
      <div className="rav-admin-list">
        {data.subscribers.map((s, i) => (
          <div key={s.id} className="rav-admin-row" data-testid={`subscriber-row-${i}`}>
            <span className="rav-admin-row-label">{s.email}</span>
            <span className="rav-admin-row-sub">inscrite le {String(s.created_at).slice(0, 10)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
